import{SignerType as r}from"../types/Signer.js";import t from"./getIframe.js";const i=e=>{e.type!==r.Extension&&t(!0)};var g=i;export{g as default};
